







import { Component, Vue } from 'vue-property-decorator';
import { StorageService } from '../../services/StorageService';
import { eventBus, EventBusEvents } from '../../services/EventBus';

@Component({})
export default class ThemeWrapper extends Vue {
  private theme: string;
  private storageService: StorageService;

  constructor() {
    super();
    this.storageService = new StorageService();
    this.theme = this.storageService.getTheme() || 'theme-base';
  }

  public created(): void {
    eventBus.$on(EventBusEvents.ChangeThemeEvent, () => {
      this.theme = this.storageService.getTheme() || 'theme-base';
    });
  }
}
